export const generateInitialValues = fields => {
  const values = {};
  if (fields?.length) {
    fields.forEach(field => {
      values[field.key] = field.value;
    });
  }
  return values;
};